'use client'
import type { UseCookiebotTriggerType } from '@maestro/cookiebot-cookie-consent/cookiebot.types'

import { useTranslations } from 'next-intl'

export const useCookiebotTrigger = (): UseCookiebotTriggerType => {
  const t = useTranslations('cookiebot-cookie-consent.cookiebot-trigger')
  const label = t('link-label')
  const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (typeof window !== 'undefined' && 'Cookiebot' in window) {
      window.Cookiebot.show()
    }
  }

  return { handleOnClick, label }
}
